var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.15,6.53H1v2H15.84v8.53c0,2.72-2.15,4.94-4.79,4.94h-3.26c-2.64,0-4.79-2.22-4.79-4.94v-5.71H1v5.71c0,3.83,3.04,6.94,6.79,6.94h3.26c3.74,0,6.79-3.11,6.79-6.94v-2.46h1.31c2.12,0,3.85-1.76,3.85-3.93v-.21c0-2.17-1.73-3.93-3.85-3.93Zm1.85,4.14c0,1.06-.83,1.93-1.85,1.93h-1.31v-4.07h1.31c1.02,0,1.85,.87,1.85,1.93v.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44,4.74c-.15,0-.29-.03-.43-.1-.5-.24-.71-.84-.47-1.33L5.86,.57c.24-.5,.84-.71,1.33-.47,.5,.24,.71,.84,.47,1.33l-1.32,2.74c-.17,.36-.53,.57-.9,.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02,4.74c-.15,0-.29-.03-.43-.1-.5-.24-.71-.84-.47-1.33l1.32-2.74c.24-.5,.84-.71,1.33-.47,.5,.24,.71,.84,.47,1.33l-1.32,2.74c-.17,.36-.53,.57-.9,.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.63,4.74c-.15,0-.29-.03-.43-.1-.5-.24-.71-.84-.47-1.33l1.32-2.74c.24-.5,.84-.71,1.33-.47,.5,.24,.71,.84,.47,1.33l-1.32,2.74c-.17,.36-.53,.57-.9,.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeBreak);
export default __webpack_public_path__ + "static/media/coffee-break.0b0b9ade972c80fb66be03bbeddd6e94.svg";
export { ForwardRef as ReactComponent };